import { DateRange, ComparePreset } from './types';
import { addDays, addMonthsClamped, daysBetween } from './dateHelpers';

// 'custom' es una B elegida a mano (Fase 2), no derivada por regla.
type DerivedComparePreset = Exclude<ComparePreset, 'custom'>;

// Invariante: length(B) === length(A), siempre. Las cuatro reglas mueven solo
// el ancla de inicio y reaplican la longitud de A al final — el recorte de
// mes ocurre en un único punto y no puede provocar deriva de longitud.
const deriveB = (a: DateRange, preset: DerivedComparePreset): DateRange => {
  const len = daysBetween(a.start, a.end) + 1;
  if(preset === 'prev-period') {
    const end = addDays(a.start, -1);
    return { start: addDays(end, -(len - 1)), end };
  }
  const months = preset === 'prev-month' ? 1 : preset === 'prev-quarter' ? 3 : 12;
  const start = addMonthsClamped(a.start, -months);
  return { start, end: addDays(start, len - 1) };
};

export { deriveB, DerivedComparePreset };
